<template>

<div class="mast">
  <div class="grid">
    <div class="mast-text">
      <h1 class="mast-title">
        <slot name="title" />
      </h1>
      <p class="mast-copy">
        <slot name="copy" />
      </p>
      <p class="mast-copy-sub">
        <slot name="copy-sub" />
      </p>
    </div>
    <div class="mast-image">
      <div class="img-wrapper">
        <Image
          v-if="imgName != null"
          draggable="false"
          :src="$IMG(`assets/images/subbanner/subbanner_${imgName}.png`)" 
          :srcset="`
            ${$IMG('assets/images/subbanner_sm/subbanner_'+imgName+'.png')} 600w,
            ${$IMG('assets/images/subbanner_md/subbanner_'+imgName+'.png')} 768w
          `"
        />
      </div>
    </div>
  </div>
</div>

</template>

<script>

export default {
  props: {
    imgName: String
  }
}

</script>

<style lang="scss" scoped>

.mast {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
  @media screen and (max-width: 940px) {
    height: 250px;
  }
}

.mast .grid {
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  padding: 0 0 0 20px;
  @media screen and (max-width: 940px) {
    grid-gap: 16px;
  }
  @media screen and (max-width: 640px) {
    padding: 0;
  }
}

.mast-text {
  position: relative;
  grid-column: span 6;
  align-self: center;
  @media screen and (max-width: 640px) {
    grid-column: span 12;
    height: 100%;
    align-self: flex-end;
    z-index: 10;
    padding: 0 16px 24px;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
  }
}

.mast-image {
  position: relative;
  grid-column: span 6;
  height: 100%;
  max-height: 300px;
  @media screen and (max-width: 940px) {
    max-height: 250px;
  }
  @media screen and (max-width: 640px) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: none;
    z-index: 1;
  }
  .img-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 50vw;
    height: 100%;
    overflow: hidden;
    @media screen and (max-width: 940px) {
      position: relative;
      top: auto;
      left: auto;
      width: 100%;
      height: 100%;
    }

  }
  img {
    position: absolute;
    display: block;
    top: 50%;
    left: 0;
    max-width: 947px;
    width: 100%;
    height: 100%;
    transform: translate3d(0, -50%, 0);
    object-fit: cover;
    @media screen and (max-width: 940px) {
      position: relative;
      top: auto;
      left: auto;
      transform: none;
      width: 100%;
      height: 100%;
    }

  }
}

h1.mast-title {
  font-weight: 700;
  font-size: 60px;
  line-height: 70px;
  color: var(--primary-500);
  margin: 0 0 20px;
  @media screen and (max-width: 940px) {
    font-size: 28px;
    line-height: 38px;
    margin: 0 0 10px;
  }
  @media screen and (max-width: 640px) {
    font-size: 24px;
    margin: auto 0 10px;
    color: white;
  }
}

p.mast-copy {
  font-weight: 700;
  font-size: var(--typ-body3);
  line-height: 26px;
  color: var(--gray-900);
  margin: 0 0 14px;
  @media screen and (max-width: 940px) {
    font-size: var(--typ-body4);
    margin: 0 0 10px;
  }
  @media screen and (max-width: 640px) {
    // margin-top: auto;
    color: white;
    font-size: var(--typ-body5);
    margin: 0 0 5px;
  }
}

p.mast-copy-sub {
  font-weight: 400;
  font-size: var(--typ-body4);
  line-height: 26px;
  color: var(--gray-700);
  margin: 0 0;
  @media screen and (max-width: 940px) {
    font-size: var(--typ-body5);
    margin: 0 0;
  }
  @media screen and (max-width: 640px) {
    // margin-top: auto;
    color: white;
    font-size: 12px;
  }
}
</style>